import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';
import { AdminService } from '@components/admin/admin.service';

export interface MarketplaceItem {
  id: string;
  name: string;
  description: string;
  image: string;
  enabled: boolean;
}

@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MarketplaceComponent implements OnInit {
  message: any;
  readonly items: MarketplaceItem[] = [
    {
      id: 'nhtsa',
      name: 'NHTSA',
      description:
        'National Highway Traffic Safety Administration is an agency of the U.S. federal government, part of the Department of Transportation with a mission to "Save lives, prevent injuries, reduce vehicle-related crashes"',
      image: '../../../../assets/img/marketplace/NHTSA.png',
      enabled: true,
    },
    {
      id: 'danlaw-veco',
      name: 'Danlaw VECO',
      description:
        "Danlaw's Vehicle Compatibility (VECO) services allow you to decode a VIN and find out the OBD Device compatibility with your vehicles.",
      image: '../../../../assets/img/marketplace/danlaw_veco.png',
      enabled: true,
    },
    {
      id: 'att',
      name: 'AT&T',
      description:
        "AT&T is the world's largest telecommunications company and the largest provider of mobile telephone services in the U.S.",
      image: '../../../../assets/img/marketplace/at_t.png',
      enabled: true,
    },
    {
      id: 'bird',
      name: 'BIRD Analytics',
      description:
        'BIRD Analytics is a user focused platform designed to acquire data from ANY source and transform it into decision-making and usable insights.',
      image: '../../../../assets/img/marketplace/bird_analytics.png',
      enabled: true,
    },
    {
      id: 'danlaw-ds',
      name: 'Danlaw Data Science',
      description:
        'Danlaw Data Science provides pre-configured advanced analytics APIs for Driver Risk Scoring, Insurance Scoring, Fuel Economy Scoring, Vehicle Health Scoring, EV Battery Health Scoring, Crash Classification and Road Surface Classification.',
      image: '../../../../assets/img/marketplace/danlaw_data_science.png',
      enabled: true,
    },
  ];

  constructor(
    private adminService: AdminService,
    private title: Title,
  ) {}

  ngOnInit(): void {
    this.title.setTitle('Marketplace' + environment.title_text);
    this.message = this.adminService.getSideMenu();
  }
}
